var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconprevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8277 16.2652C8.05271 16.4763 8.40521 16.4688 8.62102 16.2483C8.84338 16.0211 8.83556 15.6555 8.6037 15.438L2.56156 9.77041C1.71927 8.98032 1.71927 7.64309 2.56155 6.85301L8.6037 1.18537C8.83556 0.967877 8.84338 0.602299 8.62102 0.375096C8.40521 0.154587 8.05271 0.14707 7.8277 0.358179L0.905001 6.85315C0.0629172 7.64321 0.0629157 8.98021 0.905 9.77026L7.8277 16.2652ZM5.8349 9.77026C4.99281 8.98021 4.99281 7.64321 5.8349 6.85315L12.7576 0.35818C12.9826 0.14707 13.3351 0.154586 13.5509 0.375096C13.7733 0.602299 13.7655 0.967877 13.5336 1.18537L7.49145 6.85301C6.64916 7.64309 6.64916 8.98032 7.49145 9.7704L13.5336 15.438C13.7655 15.6555 13.7733 16.0211 13.5509 16.2483C13.3351 16.4688 12.9826 16.4763 12.7576 16.2652L5.8349 9.77026Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconprevious);
export default __webpack_public_path__ + "static/media/iconprevious.d85481e022a94e88edbb6a1de2aef9a6.svg";
export { ForwardRef as ReactComponent };